export const MAIN_SET_LANGUAGE = 'MAIN_SET_LANGUAGE'
export const MAIN_SET_AUTH_INTENT = 'MAIN_SET_AUTH_INTENT'
